const API_URL = process.env.REACT_APP_API_URL;

const procesarRespuesta = async (res, msgDefault) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.message || msgDefault);
  }
  return data;
};

// Usamos el prefijo /api/th que ya está montado en tu servidor Express
export const getActasCompromiso = async () => {
  const res = await fetch(`${API_URL}/api/th/actas-compromiso`);
  return procesarRespuesta(res, "Error obteniendo actas de compromiso");
};

export const getActaCompromisoById = async (id) => {
  const res = await fetch(`${API_URL}/api/th/actas-compromiso/${id}`);
  return procesarRespuesta(res, "Error obteniendo detalle del acta");
};

export const crearActaCompromiso = async (data) => {
  const res = await fetch(`${API_URL}/api/th/actas-compromiso`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return procesarRespuesta(res, "Error al crear el acta");
};

export const actualizarActaCompromiso = async (id, data) => {
  const res = await fetch(`${API_URL}/api/th/actas-compromiso/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return procesarRespuesta(res, "Error al actualizar el acta");
};

export const eliminarActaCompromiso = async (id) => {
  const res = await fetch(`${API_URL}/api/th/actas-compromiso/${id}`, {
    method: 'DELETE'
  });
  return procesarRespuesta(res, "Error al eliminar el acta");
};